import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero/Hero';
import gallery from '../data/galleryManifest.json';
import flagRaising from '../assets/images/flag-raising.jpg';
import './Home.css';

const STATS = [
  { value: '1963', label: 'Founded' },
  { value: '~300', label: 'Residents of the House' },
  { value: '65th', label: 'Anniversary in 2027' },
  { value: '4', label: 'Values on the Eiffel' },
];

const SPORT_SLUGS = [
  'sport-004', 'sport-018', 'sport-020', 'sport-023', 'sport-027',
  'sport-032', 'sport-037', 'sport-048', 'sport-052', 'sport-053',
];

export default function Home() {
  const preview = gallery.slice(0, 6);
  const sportPhotos = SPORT_SLUGS
    .map((id) => gallery.find((p) => p.id === id))
    .filter(Boolean);

  return (
    <>
      <Hero />

      {/* Welcome */}
      <section id="about" className="section">
        <div className="container home-welcome__grid">
          <div className="home-welcome__text">
            <p className="section__eyebrow">Since 1963</p>
            <h2>Welcome to House TAU</h2>
            <p className="prose">
              House TAU is built on the motto "Iron Sharpens Iron." From the Eiffel in the
              quad to the Ampsmotor parked in tradition, our history runs deep, and 2027
              brings our 65th anniversary, the feesjaar the homepage animation above is
              counting down to.
            </p>
            <p className="prose">
              Every resident is welcomed into a brotherhood built on pride, tradition,
              respect, and loyalty, values carried by every generation of Ysters who've
              called this House home.
            </p>
            <Link to="/about" className="home-link">Read the full House story →</Link>
          </div>
          <div className="home-welcome__media">
            <img src={flagRaising} alt="House TAU flag being raised" />
          </div>
        </div>
      </section>

      {/* Quick facts */}
      <section className="section section--tight">
        <div className="container home-stats-wrap">
          <div className="home-stats">
            {STATS.map((s) => (
              <div className="home-stats__item" key={s.label}>
                <span className="home-stats__value">{s.value}</span>
                <span className="home-stats__label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* House Parents + Baltsazar teaser, side by side */}
      <section className="section section--alt">
        <div className="container home-cards">
          <div className="home-card">
            <p className="section__eyebrow">Leadership</p>
            <h3>House Parents</h3>
            <p className="prose">
              Dr Bernard Coetzee &amp; Tannie Hanrie Coetzee lead House TAU as Heads of
              Residence, looking after every resident from first year through to
              graduation.
            </p>
            <Link to="/about" className="home-link">Meet the House →</Link>
          </div>
          <div className="home-card">
            <p className="section__eyebrow">Est. 1963</p>
            <h3>Baltsazar</h3>
            <p className="prose">
              House TAU's own clubhouse, home to socials and everything that
              comes with them.
            </p>
            <Link to="/baltsazar" className="home-link">Visit the clubhouse →</Link>
          </div>
        </div>
      </section>

      {/* Sport */}
      <section className="section">
        <div className="container">
          <div className="home-section-header">
            <div>
              <p className="section__eyebrow">On the field</p>
              <h2>Sport at House TAU</h2>
            </div>
            <Link to="/gallery?filter=sports" className="home-link">View all sport photos →</Link>
          </div>
          <p className="section__lede">
            Rugby, hockey, netball, volleyball, and everything in between, TAU competes
            with pride across every code.
          </p>
          <div className="home-sport-grid">
            {sportPhotos.map((photo) => (
              <Link key={photo.id} to="/gallery?filter=sports" className="home-sport-grid__item">
                <img src={photo.thumb} alt="" loading="lazy" />
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery preview */}
      <section className="section section--alt">
        <div className="container">
          <div className="home-section-header">
            <h2>From the Gallery</h2>
            <Link to="/gallery" className="home-link">View full gallery →</Link>
          </div>
          <div className="home-gallery-grid">
            {preview.map((photo) => (
              <Link key={photo.id} to="/gallery" className="home-gallery-grid__item">
                <img src={photo.thumb} alt="" loading="lazy" />
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
